const EMAIL_LIKE = /@/;
const EMAIL_FORMAT = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const INDIAN_MOBILE = /^[6-9]\d{9}$/;

export function looksLikeEmail(value) {
  return EMAIL_LIKE.test(String(value || ''));
}

export function isValidEmail(value) {
  return EMAIL_FORMAT.test(String(value || '').trim());
}

export function normalizeIndianMobile(value) {
  let digits = String(value || '').replace(/\D/g, '');
  if (digits.startsWith('91') && digits.length >= 12) {
    digits = digits.slice(2);
  } else if (digits.startsWith('0') && digits.length >= 11) {
    digits = digits.slice(1);
  }
  return digits.slice(0, 10);
}

export function isValidIndianMobile(value) {
  return INDIAN_MOBILE.test(String(value || ''));
}

export function phoneFieldError(rawValue, normalizedValue) {
  if (looksLikeEmail(rawValue)) {
    return 'Enter a 10-digit mobile number, not an email. Use the Email field below.';
  }
  if (!normalizedValue) {
    return 'Enter a 10-digit Indian mobile number.';
  }
  if (normalizedValue.length < 10) {
    return 'Enter a 10-digit mobile number.';
  }
  if (!isValidIndianMobile(normalizedValue)) {
    return 'Enter a valid 10-digit Indian mobile number.';
  }
  return '';
}
